//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import contentHearder from '../../components/content-hearder';
import { gettemplatedraftlist, addtotemplate } from '@/api/templateManagement.js';
export default {
  components: {
    contentHearder,
  },
  data() {
    return {
      tableData: [], // 展示数据
      page_index: 1,
      page_size: 10,
      total: 0,
      loading: false,
      allData: [], // 总共数据
      // 模板选择弹窗
      chooseDrafId: null,
      selectTemplate: false,
      templateType: 0,
      submitLoading: false,
      appid: this.$route.query.appid,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    // 获取草稿箱列表
    getList() {
      this.loading = true;
      gettemplatedraftlist({ app_id: this.appid })
        .then((data) => {
          let allData = [];
          allData = (data.list || []).map((item) => {
            return {
              ...item,
            };
          });
          this.allData = allData;
          this.tableData = allData.slice(0, this.page_size);
          this.total = allData.length || 0;
          this.loading = false;
        })
        .catch(({ errmsg }) => {
          this.loading = false;
          this.$message.error(errmsg);
        });
    },
    chooseTemplate(id) {
      this.chooseDrafId = id;
      this.selectTemplate = true;
    },
    // 添加到代码模板库
    handleAdd() {
      this.$confirm('确定把草稿箱代码添加到代码库？', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.submitLoading = true;
          addtotemplate({
            appid: this.appid,
            path: '/wxa/addtotemplate',
            body: JSON.stringify({
              draft_id: Number(this.chooseDrafId),
              template_type: this.templateType,
            }),
          })
            .then(() => {
              this.submitLoading = false;
              this.$message.success('添加成功！');
              this.selectTemplate = false;
            })
            .catch(() => {
              this.submitLoading = false;
              this.$message.success('添加失败！');
            });
        })
        .catch(() => {});
    },

    handleCurrent(val) {
      this.page_index = val;
      this.tableData = this.allData.slice(
        (this.page_index - 1) * this.page_size,
        val * this.page_size,
      );
    },
  },
};
